import { useFormState, Field } from "react-final-form";

export const Condition = ({ when, children }) => {
  const { values = {} } = useFormState({ subscription: { values: true } });

  return when(values) ? children : null;
};
